module.exports = "<div class=pose-image hm-tap=\"$ctrl.AppServices.HeroManager.setPose('standing')\" ng-style=\"{'background-image':'url({{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.image}})'}\"></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/pose-image/pose-image.html
 ** module id = 84
 ** module chunks = 0
 **/